import React, { useState } from "react";
import style from "../../style/Pages/Help/Help.module.css";
import { Search } from "lucide-react";
import {
  IoPersonOutline,
  IoHomeOutline,
  IoChatbubbleEllipsesOutline,
} from "react-icons/io5";
import { GrGroup } from "react-icons/gr";
import { FiNavigation } from "react-icons/fi";
import { TbAutomation, TbArrowRightDashed } from "react-icons/tb";
import { Link } from "react-router-dom";
import SecondaryLayout from "../../layouts/SecondaryLayout";

const helpTopics = [
  {
    title: "My account",
    description: "Welcome to our chat application! Here's how to get started",
    icon: <IoPersonOutline className={style.iconStyle} />,
    link: "/help/my-account",
  },
  {
    title: "Home Panel",
    description:
      "The Home Panel is your central hub for navigating through the app",
    icon: <IoHomeOutline className={style.iconStyle} />,
    link: "/help/home-panel",
  },
  {
    title: "Chat Features",
    description:
      "Our chat application is packed with intuitive and powerful features to help you connect and collaborate efficiently",
    icon: <IoChatbubbleEllipsesOutline className={style.iconStyle} />,
    link: "/help/chat-features",
  },
  {
    title: "Activity",
    description:
      "The Activity section helps you keep track of recent interactions and updates in your chat environment.",
    icon: <GrGroup className={style.iconStyle} />,
    link: "/help/activity",
  },
  {
    title: "Navigation",
    description:
      "Easily find your way around the chat application with a clean and intuitive interface",
    icon: <FiNavigation className={style.iconStyle} />,
    link: "/help/navigation",
  },
  {
    title: "Settings",
    description:
      "The Settings section lets you customize your chat experience according to your preferences.",
    icon: <TbAutomation className={style.iconStyle} />,
    link: "/help/settings",
  },
];

const Help = () => {
  const [searchTerm, setSearchTerm] = useState("");

  // Filter topics based on search
  const filteredTopics = helpTopics.filter(
    ({ title, description }) =>
      title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <SecondaryLayout>
        <div className={style.helpWrapper}>
          <div className={style.subDIv}>
            <h1 className={style.helpHeader}>We're here to help</h1>

            <div className={style.searchBox}>
              <Search size={18} className={style.helpIcon} />
              <input
                type="text"
                placeholder="Search"
                className={style.searchInput}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>

          <div className={style.cardsGrid}>
            {filteredTopics.length > 0 ? (
              filteredTopics.map(
                ({ title, description, icon, link }, index) => (
                  <div className={style.helpCard} key={index}>
                    <div className={style.helpIconBox}>{icon}</div>
                    <h3>{title}</h3>
                    <hr className={style.divider} />
                    <p className={style.discription}>{description}</p>
                    <Link to={link || "#"} className={style.learnMore}>
                      Learn more{" "}
                      <TbArrowRightDashed className={style.iconArrow} />
                    </Link>
                  </div>
                )
              )
            ) : (
              <p className={style.noResults}>No topics found.</p>
            )}
          </div>
        </div>
      </SecondaryLayout>
    </>
  );
};

export default Help;
